import { render } from "./orderDetails.vue?vue&type=template&id=f07a671a&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"

import "./orderDetails.vue?vue&type=style&index=0&id=f07a671a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f07a671a"]])

export default __exports__